/*!
 * Copyright 2024 Cognite AS
 */

/**
 * @beta
 */
export enum FlexibleMouseActionType {
  None = 'none',
  SetTarget = 'setTarget',
  SetTargetAndCameraDirection = 'setTargetAndCameraDirection',
  SetTargetAndCameraPosition = 'setTargetAndCameraPosition'
}
